import React from 'react';
import { Sparkles, BookOpen } from 'lucide-react';
import type { Book } from '../../../../shared/types/index.js';
import { LazyBookCover } from '../../../../shared/components/LazyBookCover.js';

interface BlogRelatedBooksProps {
  books: Book[];
  category?: string | null;
  onSelectBook: (book: Book) => void;
}

export const BlogRelatedBooks: React.FC<BlogRelatedBooksProps> = ({
  books,
  category,
  onSelectBook,
}) => {
  if (!books || books.length === 0) return null;

  return (
    <div className="mt-20 space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-indigo-600 animate-pulse" />
          <h3 className="text-lg font-black text-slate-900">Buku Ber-UIBN Terkait</h3>
        </div>
        <span className="text-[10px] font-black text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-lg uppercase tracking-wider">
          Kategori: {category || 'Umum'}
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {books.slice(0, 3).map((b, idx) => (
          <div
            key={`blog-rel-book-${b.id || idx}-${idx}`}
            onClick={() => onSelectBook(b)}
            className="bg-slate-50 hover:bg-white rounded-2xl p-4 border border-slate-100 hover:border-indigo-200 transition-all duration-300 cursor-pointer hover:shadow-lg group text-left flex flex-col justify-between"
          >
            <div>
              <div className="aspect-[3/4] rounded-lg overflow-hidden bg-slate-100 border border-slate-200 shadow-2xs mb-3 relative">
                <LazyBookCover
                  coverUrl={b.coverUrl}
                  title={b.title}
                  className="w-full h-full rounded-lg"
                  hoverEffect
                />
                <span className="absolute bottom-2 left-2 z-20 bg-indigo-600 text-white font-mono font-bold text-[8px] px-1.5 py-0.5 rounded shadow-2xs">
                  {b.uibn}
                </span>
              </div>
              <h4 className="font-bold text-slate-900 text-xs line-clamp-1 group-hover:text-indigo-600 transition-colors leading-snug">
                {b.title}
              </h4>
              <p className="text-[10px] text-slate-500 truncate mt-0.5">Oleh {b.authorName}</p>
            </div>
            <div className="flex items-center justify-between gap-2 mt-4 pt-2 border-t border-slate-200/50 text-[9px] text-slate-400 font-bold uppercase tracking-wider">
              <span className="truncate max-w-[60%]">{b.publisherName}</span>
              <span className="text-indigo-600 group-hover:underline shrink-0">Registry →</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
